import React from 'react';
import Icon from '../../../components/AppIcon';

const WizardProgressBar = ({ currentStep, steps, totalSteps }) => {
  const completionPercentage = Math.round(((currentStep + 1) / totalSteps) * 100);

  return (
    <div className="w-full bg-card border-b border-border">
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-6">
        {/* Completion Percentage Bar */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-foreground">
              Progression de la réservation
            </span>
            <span className="text-sm font-bold text-primary">
              {completionPercentage}% complété
            </span>
          </div>
          <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-primary to-primary/80 transition-all duration-500 ease-out"
              style={{ width: `${completionPercentage}%` }}
            />
          </div>
        </div>

        {/* Step Indicators */}
        <div className="flex items-center justify-between">
          {steps?.map((step, index) => {
            const isCompleted = index < currentStep;
            const isCurrent = index === currentStep;
            const isUpcoming = index > currentStep;

            return (
              <React.Fragment key={step?.id}>
                <div className="flex flex-col items-center flex-1">
                  <div
                    className={`w-10 h-10 lg:w-12 lg:h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                      isCompleted
                        ? 'bg-success text-success-foreground'
                        : isCurrent
                        ? 'bg-primary text-primary-foreground ring-4 ring-primary/20'
                        : 'bg-muted text-muted-foreground'
                    }`}
                  >
                    {isCompleted ? (
                      <Icon name="Check" size={20} />
                    ) : (
                      <span className="text-sm lg:text-base font-semibold">{index + 1}</span>
                    )}
                  </div>
                  <span
                    className={`mt-2 text-xs lg:text-sm font-medium text-center transition-colors ${
                      isCurrent ? 'text-foreground' : 'text-muted-foreground'
                    }`}
                  >
                    {step?.label}
                  </span>
                </div>
                {index < steps?.length - 1 && (
                  <div className="flex-1 h-0.5 mx-2 lg:mx-4 mb-8">
                    <div
                      className={`h-full transition-all duration-300 ${
                        isCompleted ? 'bg-success' : 'bg-muted'
                      }`}
                    />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WizardProgressBar;